import { Select } from 'antd';
import { Panel } from './Panel';
import { useQuery } from '@tanstack/react-query';
import { queries } from 'services/queries';
import { useMemo } from 'react';
import { useTranslate } from '@tolgee/react';

interface AssignProps {
  value?: string;
  storeId: string;
  onChange?: (value: string) => void;
}

export const Assign = (props: AssignProps) => {
  const { value, storeId, onChange } = props;
  const { t } = useTranslate();

  const { data, isLoading } = useQuery({
    ...queries.tickets.assistants(storeId),
  });

  const options = useMemo(() => {
    return (
      data?.data?.assistants?.map((assistant) => ({
        label: assistant.name,
        value: assistant.id,
      })) ?? []
    );
  }, [data]);

  return (
    <Panel title={t('sidebar.taskTab.action.transfer')}>
      <Select className="w-full" value={value} onChange={onChange} loading={isLoading}>
        {options.map((option) => (
          <Select.Option key={option.value} value={option.value}>
            {option.label}
          </Select.Option>
        ))}
      </Select>
    </Panel>
  );
};
